import { ProductOverviewAttribute, ProductOverviewCard } from '@app/components/products/ProductOverviewCard';
import { ProductQuantityPreview } from '@app/components/products/ProductQuantityPreview';
import { Modal } from '@app/components/various/Modal';
import { findProductByCentraVariantId } from '@app/logic/products';
import { useModalVisibility } from '@app/utils/hooks';
import { FailedProducts, Product } from '@typings';
import { useTranslation } from 'react-i18next';

interface Props {
  failedProductsData: {
    products: Record<Product.Id, Product.Full>;
    failedProducts: FailedProducts.ItemsMissing[];
  };
}

export const MissingProductsModal = ({ failedProductsData }: Props) => {
  const { t } = useTranslation(['checkout', 'products']);
  const { isModalVisible, hideModal } = useModalVisibility('MissingProductsModal');

  const { failedProducts: variants, products } = failedProductsData;

  const data = variants.map(failedProduct => ({
    ...failedProduct,
    product: findProductByCentraVariantId(products, failedProduct.variantId),
  }));

  return (
    <Modal
      title={t('products:products_not_available')}
      description={t('products:products_not_included_in_selection')}
      size="xlarge"
      isOpen={isModalVisible}
      onClose={hideModal}
    >
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-table-mobile">
        {data.map(({ productId, variantId, product, deliveryWindow, items }) => (
          <ProductOverviewCard
            key={variantId}
            product={product}
            productId={productId}
            variantName={product?.variantName ?? variantId.toString()}
            deliveryWindowId={deliveryWindow.toString()}
          >
            <ProductOverviewAttribute
              label={t('checkout:original_quantity')}
              value={
                <ProductQuantityPreview
                  title={t('checkout:original_quantity')}
                  items={items.map(item => item.original)}
                  itemTable={product?.itemTable}
                />
              }
            />
            <ProductOverviewAttribute
              label={t('checkout:available_quantity')}
              value={
                <ProductQuantityPreview
                  title={t('checkout:available_quantity')}
                  items={items.map(item => item.new)}
                  itemTable={product?.itemTable}
                />
              }
            />
          </ProductOverviewCard>
        ))}
      </div>
    </Modal>
  );
};
